export default "__VITE_ASSET__DpuKgnNg__"